mutation AcceptEmailReplySuggestion($input: EmailAcceptSuggestedReplyInput!) {
    emailAcceptSuggestedReply(input: $input) {
        success
    }
}
